import { DateRangeBucketKey, GetDashboardDataResponse } from './get-dashboard-data-response';

export interface CrewDashboardState {
  dashboardData: GetDashboardDataResponse | undefined;
  isLoading: boolean;
  error: Error | undefined;
  selectedRange: DateRangeBucketKey;
}

export const INITIAL_CREW_DASHBOARD_STATE: CrewDashboardState = {
  dashboardData: undefined,
  isLoading: false,
  error: undefined,
  selectedRange: '6_month',
};
